<div class="exercise-list-section">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h2 class="mb-0">Exercises</h2>
    <button class="btn btn-primary" (click)="onAddExercise()">
      <span class="material-icons align-middle me-1" style="font-size:1.3rem;">add</span> Add Exercise
    </button>
  </div>
  <div *ngIf="exercises.length === 0" class="text-muted">No exercises found.</div>
  <div class="exercise-list-table-wrap">
    <table class="table table-striped" *ngIf="exercises.length">
      <thead>
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Muscle Groups</th>
          <th style="width: 120px;">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ex of exercises">
          <td>{{ ex.name }}</td>
          <td>{{ ex.description }}</td>
          <td>{{ ex.muscleGroups?.join(', ') }}</td>
          <td>
            <button class="btn btn-outline-secondary btn-sm me-2" (click)="onEditExercise(ex)">
              <span class="material-icons" style="font-size:1.1rem;">edit</span>
            </button>
            <button class="btn btn-outline-danger btn-sm" (click)="onDeleteExercise(ex)">
              <span class="material-icons" style="font-size:1.1rem;">delete</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

